import { DatePicker as ArkUiDatePicker } from "@ark-ui/react";
import Header from "./Header";
import { AromaDatepickerRecipe } from "@zenchef/styled-system/recipes";
import { Text } from "../../typography/Text";
import { Translations } from "./types";

interface Props {
  classes: ReturnType<AromaDatepickerRecipe>;
  translations: Translations;
}

export default function YearView({ classes, translations }: Props) {
  return (
    <ArkUiDatePicker.View view="year" data-view-year className={classes.view}>
      <ArkUiDatePicker.Context>
        {(datePicker) => (
          <>
            <Header
              datePicker={datePicker}
              classes={classes}
              translations={translations}
            />
            <ArkUiDatePicker.Table className={classes.table}>
              <ArkUiDatePicker.TableBody className={classes.body}>
                {datePicker.getYearsGrid({ columns: 3 }).map((years, id) => (
                  <ArkUiDatePicker.TableRow key={id} className={classes.row}>
                    {years.map((year, id) => (
                      <ArkUiDatePicker.TableCell
                        key={id}
                        value={year.value}
                        className={classes.yearContainer}
                      >
                        <ArkUiDatePicker.TableCellTrigger
                          className={classes.year}
                        >
                          <Text textStyle="paragraph.m.bold">{year.label}</Text>
                        </ArkUiDatePicker.TableCellTrigger>
                      </ArkUiDatePicker.TableCell>
                    ))}
                  </ArkUiDatePicker.TableRow>
                ))}
              </ArkUiDatePicker.TableBody>
            </ArkUiDatePicker.Table>
          </>
        )}
      </ArkUiDatePicker.Context>
    </ArkUiDatePicker.View>
  );
}
